import { combineReducers } from 'redux';
import content from './privacy-policy-content';
import hasError from './privacy-policy-error';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';

const privacyPolicy = combineReducers({
  content,
  hasError,
  isLoading: loadingStatusAccordingToReducer('privacyPolicyLoadingStatus'),
});

export default privacyPolicy;



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/reducers/privacy-policy.js